
import { Component, Vue, Prop } from "vue-property-decorator";
import {deleteRelationClaim} from "@/api/supplier-payment";

@Component({
  name: "CreateFee"
})
export default class extends Vue {
  @Prop({ default: "其他费用" }) private title: "";
  @Prop({ default: false }) private showButton: boolean;
  @Prop({ default: "" }) private state: "";
  @Prop({ default: "" }) private paymentVoucherId: "";

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "索赔单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false
    },
    {
      label: "产品",
      prop: "claimProducts",
      key: "claimProducts",
      show: true,
      disabled: false
    },
    {
      label: "生成时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false
    },
    {
      label: "索赔金额",
      prop: "claimAmount",
      key: "claimAmount",
      show: true,
      disabled: false
    },
    {
      label: "未抵扣金额",
      prop: "unClaimDeduction",
      key: "unClaimDeduction",
      show: true,
      disabled: false
    },
    {
      label: "抵扣金额",
      prop: "claimDeduction",
      key: "claimDeduction",
      show: true,
      disabled: false
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: '',
          click: "handleDelete",
          type: "delete"
        }
      ],
      show: true,
      disabled: false,
      width: 100
    }
  ] as any;

  public tableCol1 = [
    {
      label: "索赔单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false
    },
    {
      label: "产品",
      prop: "claimProducts",
      key: "claimProducts",
      show: true,
      disabled: false
    },
    {
      label: "生成时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false
    },
    {
      label: "索赔金额",
      prop: "claimAmount",
      key: "claimAmount",
      show: true,
      disabled: false
    },
    {
      label: "未抵扣金额",
      prop: "unClaimDeduction",
      key: "unClaimDeduction",
      show: true,
      disabled: false
    },
    {
      label: "抵扣金额",
      prop: "claimDeduction",
      key: "claimDeduction",
      show: true,
      disabled: false
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false
    }
  ] as any;

  //  删除
  public async handleDelete(scope) {
    const params = {
      paymentVoucherId: this.paymentVoucherId,
      claimFormId: scope.row.claimFormId,
    }
    await deleteRelationClaim(params).then(() => {
      this.table.list.splice(scope.$index, 1);
      this.$emit("deletedRelationClaim", scope.row.claimDeduction);
      this.$notify({
        title: '成功',
        message: '操作成功',
        type: 'success'
      });
    });
  }
}
